import axios from 'axios';
import type { Worksheet } from '@/models/worksheet';
import type { Lesson } from '@/models/lesson';
import { axiosV2 } from '@/main';

class TradeWorksheetWebserviceV2 {
    public getById(worksheetId: number) {
        return axios.get<Worksheet>('/worksheets/getById', {
            params: {
                worksheetId,
            },
        });
    }

    public store(worksheet: Worksheet, lessons: Lesson[]) {
        return axiosV2.post('/worksheets/store', {
            project_id: worksheet.project.id,
            trade_id: worksheet.trade.id,
            phase_id: worksheet.phase.id,
            lessons,
        });
    }
}

export const tradeWorksheetWebserviceV2 = new TradeWorksheetWebserviceV2();
